import { useMemo, useState } from "react"
import { Box, Grid, Stack, Typography } from "@mui/material"
import HelpIcon from '@mui/icons-material/Help';

import BaseButton from "../BaseButton";
import BaseImage from "../BaseImage";
import BaseSwitch from "../BaseSwitch";
import AgeInput from "../AgeInput";
import BasePrettoSlider from "../BasePrettoSlider";
import BaseCircleRadioGroup from "../BaseCircleRadioGroup";

import IconBulb from "../../assets/images/icons/icon-bulb.svg"
import { GENDERS, RECOMMENDATION_TEXT } from "../../constants";

const RiskScoreCalculatorForm = ({ isOpened }) => {
  const [formStates, setFormStates] = useState({
    sex: GENDERS[0].title,
    age: 50,
    race: '',
    totalCholesterol: 130,
    hdlCholesterol: 20,
    systolicBloodPressure: 120,
    diastolicBloodPressure: 60,
    diabetes: '',
    currentSmoking: '',
    treatmentForHypertension: ''
  })
  
  const [tenYearRisk, setTenYearRisk] = useState(0)
  const [tenYearOptimal, setTenYearOptimal] = useState(0)
  const [yourLifeTimeRisk, setYourLifeTimeRisk] = useState(0)
  const [lifeTimeRisk, setLifeTimeRisk] = useState(0)
  const [recommendationText, setRecommendationText] = useState()

  const [isResult, setIsResult] = useState(false)

  const isCalculator = useMemo(() =>
    formStates.age > 0 && formStates.race && formStates.diabetes && formStates.currentSmoking && formStates.treatmentForHypertension && formStates.totalCholesterol >= 130 && formStates.hdlCholesterol >= 20 && formStates.systolicBloodPressure >= 120 && formStates.diastolicBloodPressure >= 60
  , [formStates])

  const handleChangeFormStates = (value, name) => {
    setIsResult(false)
    setFormStates({ ...formStates, [name]: value })
  }

  const onChangeSlider = (e, value) => {
    setIsResult(false)
    setFormStates({ ...formStates, [e.target.name]: value })
  }

  const handleClickCalculator = () => {
    setIsResult(true)
    const { sex, age, race, totalCholesterol, hdlCholesterol, systolicBloodPressure, diastolicBloodPressure, diabetes, currentSmoking, treatmentForHypertension } = formStates

    const genderSelect = sex === 'MALE' ? 0 : 1 
    const isTreatment = treatmentForHypertension === 'Yes'
    const isSmoke = currentSmoking === 'Yes'
    const isDiabetes = diabetes === 'Yes'
    
    const AgeConverted = () => {
      return Math.log(age)
    }
    
    const AgeSquared = () => {
      return AgeConverted() * AgeConverted()
    }
    
    const HDLCholesterolConverted = () => {
      return Math.log((hdlCholesterol))
    }
    
    const TotalCholesterolConverted = () => {
      return Math.log((totalCholesterol))
    }
    
    const agetc = () => {
      return TotalCholesterolConverted() * AgeConverted()
    }
    
    const agehdl = () => {
      return HDLCholesterolConverted() * AgeConverted()
    }
    
    const agetsbp = () => {
      return AgeConverted() * trlnsbp()
    }
    
    const agentsbp = () => {
      return AgeConverted() * ntlnsbp()
    }
    
    const trlnsbp = () => {
      return Math.log(systolicBloodPressure) * (isTreatment ? 1 : 0)
    }
    
    const ntlnsbp = () => {
      return Math.log(systolicBloodPressure) * (isTreatment ? 0 : 1)
    }
    
    const agesmoke = () => {
      return AgeConverted() * (isSmoke ? 1 : 0)
    }
    
    // const agedm = () => {
    //   return AgeConverted() * (isDiabetes ? 1 : 0)
    // }
    
    const opt_hdl = () => {
      return Math.log(50)
    }
    
    const opt_tc = () => {
      return Math.log(170)
    }
    
    const opt_agetc = () => {
      return opt_tc() * AgeConverted()
    }
    
    const opt_agehdl = () => {
      return opt_hdl() * AgeConverted()
    }
  
    const opt_agetsbp = () => {
      return AgeConverted() * opt_trlnsbp()
    }
  
    const opt_agentsbp = () => {
      return AgeConverted() * opt_ntlnsbp()
    }
  
    const opt_trlnsbp = () => {
      return Math.log(110) * 0
    }
  
    const opt_ntlnsbp = () => {
      return Math.log(110) * 1
    }
  
    const otp_agesmoke = () => {
      return AgeConverted() * 0
    }
  
    // const opt_agedm = () => {
    //   return AgeConverted() * 1
    // }
    
    const s010 = () => {
      let i = 0.0
      if (race === 'African-American' && genderSelect === 1) { i = 0.95334 }
      if (race !== 'African-American' && genderSelect === 1) { i = 0.96652 }
      if (race === 'African-American' && genderSelect === 0) { i = 0.89536 }
      if (race !== 'African-American' && genderSelect === 0) { i = 0.91436 }
      return i
    }
    
    const mnxb = () => {
      let i = 0.0
      if (race === 'African-American' && genderSelect === 1) { i = 86.6081 }
      if (race !== 'African-American' && genderSelect === 1) { i = -29.1817 }
      if (race === 'African-American' && genderSelect === 0) { i = 19.5425 }
      if (race !== 'African-American' && genderSelect === 0) { i = 61.1816 }
      return i
    }
    
    const predictCalculate = () => {
      let i
      if (race === 'African-American' && genderSelect === 1)
      { i = 17.1141 * AgeConverted() + 0.9396 * TotalCholesterolConverted() - 18.9196 * HDLCholesterolConverted() + 4.4748 * agehdl() + 29.2907 * trlnsbp() - 6.4321 * agetsbp() + 27.8197 * ntlnsbp() - 6.0873 * agentsbp() + 0.6908 * (isSmoke ? 1 : 0) + 0.8738 * (isDiabetes ? 1 : 0)
      }
      if (race !== 'African-American' && genderSelect === 1)
      { i = -29.799 * AgeConverted() + 4.884 * AgeSquared() + 13.54 * TotalCholesterolConverted() - 3.114 * agetc() - 13.578 * HDLCholesterolConverted() + 3.149 * agehdl() + 2.019 * trlnsbp() + 1.957 * ntlnsbp() + 7.574 * (isSmoke ? 1 : 0) - 1.665 * agesmoke() + 0.661 * (isDiabetes ? 1 : 0)
      }
      if (race === 'African-American' && genderSelect === 0)
      { i = 2.469 * AgeConverted() + 0.302 * TotalCholesterolConverted() - 0.307 * HDLCholesterolConverted() + 1.916 * trlnsbp() + 1.809 * ntlnsbp() + 0.549 * (isSmoke ? 1 : 0) + 0.645 * (isDiabetes ? 1 : 0)
      }
      if (race !== 'African-American' && genderSelect === 0)
      { i = 12.344 * AgeConverted() + 11.853 * TotalCholesterolConverted() - 2.664 * agetc() - 7.99 * HDLCholesterolConverted() + 1.769 * agehdl() + 1.797 * trlnsbp() + 1.764 * ntlnsbp() + 7.837 * (isSmoke ? 1 : 0) - 1.795 * agesmoke() + 0.658 * (isDiabetes ? 1 : 0)
      }
      return i
    }
    
    const optimalPredictCalculate = () => {
      let i = 0.0
      if (race === 'African-American' && genderSelect === 1) 
      { i = 17.1141 * AgeConverted() + 0.9396 * opt_tc() - 18.9196 * opt_hdl() + 4.4748 * opt_agehdl() + 29.2907 * opt_trlnsbp() - 6.4321 * opt_agetsbp() + 27.8197 * opt_ntlnsbp() - 6.0873 * opt_agentsbp() + 0.6908 * 0 + 0.8738 * 0
      }
      if (race !== 'African-American' && genderSelect === 1) 
      { i = -29.799 * AgeConverted() + 4.884 * AgeSquared() + 13.54 * opt_tc() - 3.114 * opt_agetc() - 13.578 * opt_hdl() + 3.149 * opt_agehdl() + 2.019 * opt_trlnsbp() + 1.957 * opt_ntlnsbp() + 7.574 * 0 - 1.665 * otp_agesmoke() + 0.661 * 0
      }
      if (race === 'African-American' && genderSelect === 0) 
      { i = 2.469 * AgeConverted() + 0.302 * opt_tc() - 0.307 * opt_hdl() + 1.916 * opt_trlnsbp() + 1.809 * opt_ntlnsbp() + 0.549 * 0 + 0.645 * 0
      }
      if (race !== 'African-American' && genderSelect === 0) 
      { i = 12.344 * AgeConverted() + 11.853 * opt_tc() - 2.664 * opt_agetc() - 7.99 * opt_hdl() + 1.769 * opt_agehdl() + 1.797 * opt_trlnsbp() + 1.764 * opt_ntlnsbp() + 7.837 * 0 - 1.795 * otp_agesmoke() + 0.658 * 0
      }
      return i
    }
    
    //MARK: Calculate 10 years
    const predict = predictCalculate()
    const optimalPredict = optimalPredictCalculate()
    
    const computedValuesAvailable = () => {
      return predict !== null && optimalPredict !== null
    }
    
    const calculatecvdPredict = () => {
      if (computedValuesAvailable()) {
        if (predict) {
          return 1 - Math.pow(s010(), Math.exp(predict - mnxb()))
        }
        return null
      }
      else {
        return null
      }
    }
    
    const calculateoptimalCvdPredict = () => {
      if (computedValuesAvailable()) {
        if (optimalPredict) {
          return 1 - Math.pow(s010(), Math.exp(optimalPredict - mnxb()))
        }
        return null
      }
      else {
        return null
      }
    }
    
    //MARK: Calculate 10 years
    const cvdPredict = calculatecvdPredict()
    const optimalCvdPredict = calculateoptimalCvdPredict()
    
    //MARK: Result Ten Years Risk
    const TenYearRisk = () => {
      let i = "~%"
      if (cvdPredict !== 1 && !isNaN(cvdPredict)) {
        let number = cvdPredict * 100
        i = number.toFixed(1) + "%"
      }
      return i
    }
    
    //MARK: Result Ten Years Optimal
    const TenYearOptimal = () => {
      var i = "~%";
      if (optimalCvdPredict !== 1 && !isNaN(optimalCvdPredict)) {
          var number = optimalCvdPredict * 100;
          i = number.toFixed(1) + "%";
      }
      return i;
    }

    //MARK: Calculate 10 years, use const after Submit(=> )
    setTenYearRisk(TenYearRisk())
    setTenYearOptimal(TenYearOptimal())
    
    //MARK: Calculate Life Time, user after submit
    let majorTemp = 0
    let elevatedTemp = 0
    let allOptimalTemp = 0
    let notOptimalTemp = 0

    const calculatemajor = () => {
      let tc = totalCholesterol
      let bp = systolicBloodPressure
      let dbp = diastolicBloodPressure
      
      return (tc >= 240 ? 1 : 0) + (bp >= 160 ? 1 : 0) + (dbp >= 100 ? 1 : 0) + (isTreatment ? 1 : 0) + (isSmoke ? 1 : 0) + (isDiabetes ? 1 : 0)
    }
    majorTemp = calculatemajor()

    const calculateelevated = () => {
      let tc = totalCholesterol
      let bp = systolicBloodPressure
      let dbp = diastolicBloodPressure
      
      return ((tc >= 200 && tc < 240 ? 1 : 0) + (dbp >= 90 && dbp < 100 ? 1 : 0) + (bp >= 140 && bp < 160 && !isTreatment ? 1 : 0) >= 1 ? 1 : 0) * (majorTemp === 0 ? 1 : 0)
    }
    elevatedTemp = calculateelevated()
    
    const calculateallOptimal = () => {
      let tc = totalCholesterol
      let bp = systolicBloodPressure
      let dbp = diastolicBloodPressure
      
      return ((tc < 180 ? 1 : 0) + (bp < 120 ? 1 : 0) + (dbp < 80 ? 1 : 0) * (isTreatment ? 0 : 1) === 3 ? 1 : 0) * (majorTemp === 0 ? 1 : 0)
    }
    allOptimalTemp = calculateallOptimal()
    
    const calculatenotOptimal = () => {
      let tc = totalCholesterol
      let bp = systolicBloodPressure
      let dbp = diastolicBloodPressure
      
      return ((tc >= 180 && tc < 200 ? 1 : 0) + (dbp >= 80 && dbp < 100 ? 1 : 0) + (bp >= 120 && bp < 140 && !isTreatment ? 1 : 0)) * (elevatedTemp === 0 ? 1 : 0) * (majorTemp === 0 ? 1 : 0) >= 1 ? 1 : 0
    }
    notOptimalTemp = calculatenotOptimal()
    
    //MARK: Result LifeTimeRisk
    setLifeTimeRisk(genderSelect === 0 ? "5%" : "8%")

    //yourLifeTimeRisk code for DB requirement changes
    const ascvdTable = {
      female: {
          major2: 50,
          major1: 39,
          elevated: 39,
          notOptimal: 27,
          allOptimal: 8
      },
      male: {
          major2: 69,
          major1: 50,
          elevated: 46,
          notOptimal: 36,
          allOptimal: 5
      }
    };
    const lookupASCVD = (category) => {
        if (sex) return ascvdTable[sex.toLowerCase()][category];
        return "~";
    };
    const calculateYourLifeTimeRisk = () => {
      let i = "~";
      if (computedValuesAvailable()) {
        if (majorTemp > 1) i = lookupASCVD("major2");
        if (majorTemp === 1) i = lookupASCVD("major1");
        if (elevatedTemp === 1) i = lookupASCVD("elevated");
        if (notOptimalTemp === 1) i = lookupASCVD("notOptimal");
        if (allOptimalTemp === 1) i = lookupASCVD("allOptimal");
      }
      return `${i}%`; //i + "%";
    }
    setYourLifeTimeRisk(calculateYourLifeTimeRisk())
    
    const recommendationType = () => {
      let i = "";
      let cvRisk = null;
      
      if (cvdPredict !== 1 && !isNaN(cvdPredict)) {
          var number = cvdPredict * 100;
          cvRisk = number.toFixed(1);
      }

      if (cvRisk != null) {
          if (isDiabetes) {
              if (age > 75) {
                  i = RECOMMENDATION_TEXT.CASE_1;
              }
              if (age >= 40 && age <= 75) {
                  if (cvRisk < 20) {
                      i = RECOMMENDATION_TEXT.CASE_7;
                  } else if (cvRisk >= 20) {
                      i = RECOMMENDATION_TEXT.CASE_8;
                  }
              }
          } else {
              if (age > 75) {
                  i = RECOMMENDATION_TEXT.CASE_2;
              }
              if (age >= 40 && age <= 75) {
                  if (cvRisk < 5) {
                      i = RECOMMENDATION_TEXT.CASE_3;
                  } else if (cvRisk >= 5 && cvRisk <= 7.4) {
                      i = RECOMMENDATION_TEXT.CASE_4;
                  } else if (cvRisk >= 7.5 && cvRisk <= 19.9) {
                      i = RECOMMENDATION_TEXT.CASE_5;
                  } else if (cvRisk >= 20) {
                      i = RECOMMENDATION_TEXT.CASE_6;
                  }
              }
          }
          if (age >= 20 && age <= 39) {
              i = RECOMMENDATION_TEXT.CASE_9;
          }
      }
      return i;
    }
    setRecommendationText(recommendationType())
  }

  const handleReset = () => {
    setFormStates({
      sex: GENDERS[0].title,
      age: 0,
      race: '',
      totalCholesterol: 130,
      hdlCholesterol: 20,
      systolicBloodPressure: 120,
      diastolicBloodPressure: 60,
      diabetes: '',
      currentSmoking: '',
      treatmentForHypertension: ''
    })
    setIsResult(false)
  }

  return (
    <Box
      sx={{
        display: { md: isOpened ? 'block': 'none' },
        bgcolor: 'primary.white',
        padding: '24px 20px',
        borderRadius: '0 0 16px 16px'
      }}
    >
      <Stack spacing={'40px'} direction={'column'}>
        <Box>
          <Grid container spacing='32px'>
            <Grid item xs={12} md={6}>
              <BaseSwitch
                sx={{ 
                  mt: '4px',
                  height: '47px',
                }}
                title='Sex'
                selected={formStates.sex}
                onChange={(value) => handleChangeFormStates(value, 'sex')}
                options={GENDERS}
                activeColor={'#0E0F10'}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <AgeInput value={formStates.age} onChange={(value) => handleChangeFormStates(value, 'age')} />
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            width: '100%'
          }}
        >
          <BaseCircleRadioGroup
            label='Race'
            items={['Caucasian', 'African-American', 'Other']}
            value={formStates.race}
            onChange={(e) => handleChangeFormStates(e.target.value, 'race')}
          />
        </Box>
        <Box>
          <BasePrettoSlider
            title='Total Cholesterol (mg/dL)'
            name='totalCholesterol'
            min={130}
            max={240}
            value={formStates.totalCholesterol}
            onChange={onChangeSlider}
          />
        </Box>
        <Box>
          <BasePrettoSlider
            title='HDL Cholesterol (mg/dL)'
            name='hdlCholesterol'
            min={20}
            max={100}
            value={formStates.hdlCholesterol}
            onChange={onChangeSlider}
          />
        </Box>
        <Box>
          <BasePrettoSlider
            title='Systolic Blood Pressure'
            name='systolicBloodPressure'
            min={120}
            max={180}
            value={formStates.systolicBloodPressure}
            onChange={onChangeSlider}
          />
        </Box>
        <Box>
          <BasePrettoSlider
            title='Diastolic Blood Pressure'
            name='diastolicBloodPressure'
            min={60}
            max={130}
            value={formStates.diastolicBloodPressure}
            onChange={onChangeSlider}
          />
        </Box>
        <Box
          sx={{
            width: '100%'
          }}
        >
          <Grid container spacing='8px'>
            <Grid item xs={12} md={4}>
              <BaseCircleRadioGroup
                direction='column'
                label='Diabetes'
                items={['Yes', 'No']}
                value={formStates.diabetes}
                onChange={(e) => handleChangeFormStates(e.target.value, 'diabetes')}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <BaseCircleRadioGroup
                direction='column'
                label='Current smoking'
                items={['Yes', 'No']}
                value={formStates.currentSmoking}
                onChange={(e) => handleChangeFormStates(e.target.value, 'currentSmoking')}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <BaseCircleRadioGroup
                direction='column'
                label='Treatment for hypertension'
                items={['Yes', 'No']}
                value={formStates.treatmentForHypertension}
                onChange={(e) => handleChangeFormStates(e.target.value, 'treatmentForHypertension')}
              />
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container spacing='8px'>
            <Grid item xs={6}>
              <BaseButton buttonType={'default'} onClick={handleReset}>
                <Typography variant="body">Reset</Typography>
              </BaseButton>
            </Grid>
            <Grid item xs={6}>
              <BaseButton
                buttonType={'primary'}
                disabled={!isCalculator}
                onClick={handleClickCalculator}
              >
                <Typography variant="body">Calculator</Typography>
              </BaseButton>
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            display: isResult ? 'block' : 'none',
            padding: { xs: '32px 20px', md: '32px 40px' },
            borderRadius: '16px',
            bgcolor: 'primary.black',
            boxShadow: '0px 2px 20px 0px #5B87EF66'
          }}
        >
          <Grid container spacing='32px'>
            <Grid item xs={12} md={6}>
              <Stack direction={'column'} spacing={'10px'}>
                <Typography variant="h3" color='primary.white'>10-Year ASCVD Risk</Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <Typography variant="body" color='primary.mediumGray'>Calculated Risk</Typography>
                  <Typography variant="h1" color='primary.white'>{tenYearRisk}</Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Typography variant="body" color='primary.mediumGray'>Risk with optimal risk factors</Typography>
                    <HelpIcon
                      sx={{
                        fontSize: '18px',
                        color: 'primary.mediumGray',
                        ml: '8px'
                      }}
                    />
                  </Box>
                  <Typography variant="h1" color='primary.white'>{tenYearOptimal}</Typography>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction={'column'} spacing={'10px'}>
                <Typography variant="h3" color='primary.white'>Lifetime ASCVD Risk</Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <Typography variant="body" color='primary.mediumGray'>Calculated Risk</Typography>
                  <Typography variant="h1" color='primary.white'>{yourLifeTimeRisk}</Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Typography variant="body" color='primary.mediumGray'>Risk with optimal risk factors</Typography>
                    <HelpIcon
                      sx={{
                        fontSize: '18px',
                        color: 'primary.mediumGray',
                        ml: '8px'
                      }}
                    />
                  </Box>
                  <Typography variant="h1" color='primary.white'>{lifeTimeRisk}</Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
          <Box
            sx={{
              borderRadius: '8px',
              padding: '16px',
              bgcolor: 'lightGray',
              display: 'flex',
              mt: '24px'
            }}
          >
            <BaseImage
              src={IconBulb}
              sx={{
                minWidth: '24px',
                height: '24px'
              }}
            />
            <Box
              sx={{
                mt: '1px',
                ml: '2px'
              }}
            >
              <Typography variant="body">
                {recommendationText?.title}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              mt: '24px',
              lineHeight: '18px'
            }}
          >
            <Typography variant="subText" color='primary.mediumGray'>
              Disclaimer: The results and recommendations provided by this application are intended to inform but do not replace clinical judgment. Therapeutic options should be individualized and determined after discussion between the patient and their care provider.
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  )
}

export default RiskScoreCalculatorForm